import React, { ReactElement } from "react";
import ReturntopSalesProductSummaryReportList from "../../components/Reports/ReturntopSalesProductSummaryReportList";
import MainLayout from "../../components/Layouts";

const ReturntopSalesProductSummaryReportPage = (): ReactElement => {
  return (
    <MainLayout>
      <ReturntopSalesProductSummaryReportList />
    </MainLayout>
  );
}; 

export default ReturntopSalesProductSummaryReportPage;
